import React from 'react';
import PropTypes from "prop-types";
import ResourceSelector from "../../../Components/Inputs/Selects/ResourceSelector";

const AmenitySelector = (props) => {
    const getQueryParams = () => {
        let params = {};

        if (props.forBookingConfig) {
            params.category_id = props.forBookingConfig.category_id;
            params.unit_id = props.forBookingConfig.unit_id;
        }

        if (props.onlyRecurringAmenities) {
            params.only_recurring_amenities = true
        }

        return params;
    }
    return (
        <ResourceSelector
            module="bookings"
            type="amenities"
            name={props.name}
            value={props.value}
            queryParams={getQueryParams()}
            onChange={(name, value) => props.onChange(name, value)}
        />
    );
};

AmenitySelector.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    forBookingConfig: PropTypes.object,
    onlyRecurringAmenities: PropTypes.bool,
};

AmenitySelector.defaultProps = {
    name: 'amenity_id'
};

export default AmenitySelector;
